import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useSelector } from 'react-redux';
import Api from '../../../../../api/api';
import classes from './tabs.module.scss';
import Loader from '../../../../_common/Loader/Loader';
import Button from '../../../../_common/Form/Buttons/Button';
import Modal from '../../../../_common/Modal/Modal';
import InputField from '../../../../_common/Form/TextFields/InputField';
import Utils from '../../../../../utils/utils';

const Celmod = () => {
  const { physicianId } = useParams();

  const physiciansList = useSelector((store) => store.physicians.physiciansList);

  const [celmondData, setCelmondData] = useState({
    list: [],
    totalPage: 1,
  });

  const [loading, loadingToggle] = useState(true);

  const [modalIfo, setModalInfo] = useState({});
  const [error, setError] = useState(false);

  const [downloadLoadingId, setDownloadLoadingId] = useState('');
  const [saveLoading, saveLoadingToggle] = useState(false);

  const getCelmod = async () => {
    const { data } = await Api.getPhysicianCelmod({ physicianId });

    setCelmondData({
      list: data.celmod,
      // totalPage: data._meta.pageCount,
    });
  };

  useEffect(() => {
    (async () => {
      await getCelmod();

      loadingToggle(false);
    })();
  }, []);

  const changeModalData = (path, value) => {
    setModalInfo((prev) => ({ ...prev, [path]: value }));
    setError(false);
  };

  const closeModal = () => {
    setModalInfo({});
    setError(false);
  };

  const save = async (e) => {
    e.preventDefault();
    saveLoadingToggle(true);

    const data = Utils.deleteEmptyKeys(modalIfo);

    if (_.isEmpty(data)) {
      toast.error('Please fill in at least one field');
      setError(true);
    } else {
      await Api.addCelmod({ ...data, PhysicianId: physicianId });

      const sendingData = { ...celmondData, page: 1 };
      setCelmondData(sendingData);

      await getCelmod(sendingData);

      toast.success('Successfully added');
      closeModal();
    }

    saveLoadingToggle(false);
  };

  const downloadPdf = async (report) => {
    setDownloadLoadingId(report.id);

    try {
      const response = await fetch(report.path);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${physiciansList[0].firstName}_${physiciansList[0].lastName}_${report.path.split('/').pop()}`;
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (e) {
      console.error('Download error:', e);
    }

    setDownloadLoadingId('');
  };

  return (
    <div className={classes.celmod_wrapper}>
      {loading
        ? <Loader />

        : (
          <>
            <Button
              title="Add CELMoD"
              className={classes.add_btn}
              addButton
              type="button"
              reverseColor
              onClick={() => setModalInfo({
                active: '',
                therapy: '',
                relapse: '',
                therapySwitch: '',
              })}
            />

            <div className={classes.celmod_list_wrapper}>
              {celmondData.list.length
                ? celmondData.list.map((l) => (
                  <div key={l.id} className={classes.celmod_report}>
                    <div
                      className={classes.celmod_report_title}
                      onClick={() => setModalInfo(l)}
                    >
                      <p>Report</p>
                      <p>{moment.utc(l.createdAt).local().format('MM.DD.YYYY hh:mm A')}</p>
                    </div>

                    <Button
                      downloadButton
                      title="Download"
                      reverseColor
                      loading={downloadLoadingId === l.id}
                      onClick={() => downloadPdf(l)}
                    />
                  </div>
                ))

                : <p>No Data Found</p>}
            </div>
          </>
        )}

      <Modal
        open={!_.isEmpty(modalIfo)}
        onClose={() => !saveLoading && closeModal()}
        className={classes.celmod_modal}
      >
        <h3 className={classes.title}>{`${!modalIfo.id ? 'Add' : ''} CELMoD`}</h3>

        <form onSubmit={save}>
          <div className={classes.inputs_wrapper}>
            <InputField
              label="Active Revilimid Patient"
              value={modalIfo.active}
              className="w-100"
              onChange={(value) => changeModalData('active', value)}
              onKeyPress={Utils.keyPressOnlyNumber}
              onPaste={(e) => Utils.keyPressOnlyNumber(e, true)}
              disabled={!!modalIfo.id}
              error={error}
            />

            <InputField
              label="18 Months Therapy"
              value={modalIfo.therapy}
              className="w-100"
              onChange={(value) => changeModalData('therapy', value)}
              onKeyPress={Utils.keyPressOnlyNumber}
              onPaste={(e) => Utils.keyPressOnlyNumber(e, true)}
              disabled={!!modalIfo.id}
              error={error}
            />

            <InputField
              label="Potential Relapse Risk"
              value={modalIfo.relapse}
              className="w-100"
              onChange={(value) => changeModalData('relapse', value)}
              onKeyPress={Utils.keyPressOnlyNumber}
              onPaste={(e) => Utils.keyPressOnlyNumber(e, true)}
              disabled={!!modalIfo.id}
              error={error}
            />

            <InputField
              label="Expected Switch in 12 Months"
              value={modalIfo.therapySwitch}
              className="w-100"
              onChange={(value) => changeModalData('therapySwitch', value)}
              onKeyPress={Utils.keyPressOnlyNumber}
              onPaste={(e) => Utils.keyPressOnlyNumber(e, true)}
              disabled={!!modalIfo.id}
              error={error}
            />
          </div>

          {!modalIfo.id && (
            <Button
              title="Confirm"
              className={classes.btn}
              type="submit"
              loading={saveLoading}
            />
          )}
        </form>
      </Modal>
    </div>
  );
};

Celmod.propTypes = {

};

export default Celmod;
